import React, {useCallback, useEffect, useState} from 'react';

import {formatDate, toFixedValue} from "../../config";


function ProfitGraphInvestmentTable(props) {
    const classPrefix = props.classPrefix
    const items = props.items
    const translate = props.translate

    return <div className={`${classPrefix}__investment`}>
        <div className={`${classPrefix}__investment-row`}>
            <div className={`${classPrefix}__investment-cell`}>{translate.profitChartWaitProfit}</div>
            <div
                className={`${classPrefix}__investment-cell`}>{items.length > 0 ? `${toFixedValue(items[0].CycleProfitWB, 2)} ${items[0].AmountForOperWBCurr} (${toFixedValue(items[0].CycleProfitWBPrc, 2)}%)` : 0}</div>
        </div>

        <div className={`${classPrefix}__investment-row`}>
            <div className={`${classPrefix}__investment-cell`}>{translate.profitChartOpenOrders}</div>
            <div
                className={`${classPrefix}__investment-cell`}>{items.length > 0 ? `${toFixedValue(items[0].CycleProfitWBCnt, 0)}` : 0}</div>
        </div>
        <div className={`${classPrefix}__investment-row`}>
            <div className={`${classPrefix}__investment-cell`}>{translate.profitChartInOrders}</div>
            <div
                className={`${classPrefix}__investment-cell`}>{items.length > 0 ? `${toFixedValue(items[0].AmountForOperWB, 2)} ${items[0].AmountForOperWBCurr}` : 0}</div>
        </div>
        <div className={`${classPrefix}__investment-row`}>
            <div className={`${classPrefix}__investment-cell`}></div>
            <div className={`${classPrefix}__investment-cell`}>&nbsp;</div>
        </div>
        <div className={`${classPrefix}__investment-row`}>
            <div className={`${classPrefix}__investment-cell`}>{translate.profitChartInCycles}</div>
            <div
                className={`${classPrefix}__investment-cell`}>{items.length > 0 ? `${toFixedValue(items[0].AmountForOperATWK, 2)} ${items[0].AmountForOperATWKCurr}` : 0}</div>
        </div>
        <div className={`${classPrefix}__investment-row`}>
            <div className={`${classPrefix}__investment-cell`}>{translate.profitChartNewCycles}</div>
            <div
                className={`${classPrefix}__investment-cell`}>{items.length > 0 ? `${toFixedValue(items[0].AmountForOperATWKCnt, 0)}` : 0}</div>
        </div>
        <div className={`${classPrefix}__investment-row`}>
            <div className={`${classPrefix}__investment-cell`}></div>
            <div className={`${classPrefix}__investment-cell`}>&nbsp;</div>
        </div>
        <div className={`${classPrefix}__investment-row`}>
            <div
                className={`${classPrefix}__investment-cell ${classPrefix}__investment-cell--big`}>{translate.profitChartTotalInvestment}</div>
            <div
                className={`${classPrefix}__investment-cell ${classPrefix}__investment-cell--big`}>{items.length > 0 ? `${toFixedValue(items[0].AmountForOperWB_ATWK, 2)} ${items[0].AmountForOperWB_ATWKCurr}` : 0}</div>
        </div>
    </div>


}

export default ProfitGraphInvestmentTable;